import { render, staticRenderFns } from "./VwResize.vue?vue&type=template&id=3660e58b&lang=pug&"
import script from "./VwResize.vue?vue&type=script&lang=ts&"
export * from "./VwResize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VwResize.vue"
export default component.exports